import { useEffect } from "react";
import { getSiteUrl } from "../config/seo";

// Injects canonical link + JSON-LD structured data. No react-helmet needed
// for a single static page — this runs once on mount.
export const SEO = () => {
  useEffect(() => {
    const siteUrl = getSiteUrl();

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", siteUrl + "/");

  }, []);

  return null;
};
